module.exports = __webpack_public_path__ + "LBP-Logos-Solo.svg?fce8402c1cacf3edbd9a06bb02a59c31";